import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import HttpClient from "../helpers/HttpClient"
import Order, { CreateOrderDto, DuplicateOrderDto, OrderDto } from "./Order"

class OrderService {
    httpClient: HttpClient<Order, OrderDto> = new HttpClient<Order, OrderDto>(Order)

    async applyBulkDiscount(id: string, payload: object) {
        return this.httpClient.put(`/orders/${id}/bulk-discount`, payload)
    }

    async applyBulkUpdate(id: string, payload: object) {
        const order = await this.httpClient.patch(`/orders/${id}/bulk-update`, payload)
        return order
    }

    async createOrder(data: CreateOrderDto) {
        return this.httpClient.post("/orders", data)
    }

    async duplicateOrder(orderId: string, data: DuplicateOrderDto) {
        return this.httpClient.post(`/orders/${orderId}/duplicate`, data)
    }

    async isWorkflowLoading(orderId: string) {
        return AppContext.getApiClient().get(`/orders/${orderId}/reservation-workflow`)
    }
}

const instance = new OrderService()
export default instance


// WEBPACK FOOTER //
// ./src/state/order/OrderService.ts